<template>
    <div class="af-register">
        <div class="afu-w-auto afu-rounded afu-text-sm afu-text-success-400 afu-mt-2 afu-mb-5">
            {{ $t('register.welcome') }}!
        </div>
        <slot name="fields">
            <div class="afu-grid afu-grid-cols-2 afu-gap-8">
                <div>
                    <ValidationObserver
                        ref="formRegister"
                        tag="form"
                        @submit.prevent="register()"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            rules="required|verify_password"
                        >
                            <C1FormInput
                                id="password"
                                v-model="password"
                                :is-invalid="!!errors[0]"
                                :invalid-feedback="errors[0]"
                                type="password"
                                :placeholder="$t('label.create_password')"
                            />
                        </ValidationProvider>

                        <C1Alert
                            v-if="!!response.message"
                            variant="danger"
                        >
                            <div><strong>{{ response.message_title }}</strong></div>
                            <span v-html="response.message" />
                        </C1Alert>

                        <C1Button
                            type="submit"
                            variant="primary"
                            class="afu-my-4"
                            block
                            :is-busy="spinner.register"
                            size="lg"
                        >
                            {{ $t('label.register') }}
                        </C1Button>
                    </ValidationObserver>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import has  from 'lodash/has';
    import C1Button from '@/components/C1Components/C1Button';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1Alert from '@/components/C1Components/C1Alert';

    export default {
        name: 'AuthRegister',

        components: {
            ValidationObserver,
            ValidationProvider,
            C1Button,
            C1FormInput,
            C1Alert,
        },

        props: {
            email: {
                type: String,
                default: '',
            },

            variant: {
                type: String,
                default: 'primary',
            },

            hideLabels: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                password: '',
                response: {
                    message_title: '',
                    message: '',
                },
                spinner: {
                    register: false,
                },
            };
        },

        methods: {
            async register() {
                const validate = await this.$refs.formRegister.validate();
                if (!validate) {
                    return;
                }

                const data = {
                    email: this.email,
                    password: this.password,
                    recaptcha_disable: true,
                };

                this.spinner.register = true;
                this.$_register(data).then(() => {
                    this.$emit('afterRegister');
                }).catch((error) => {
                    const errorCode = has(error, 'response.data.error') ? error.response.data.error : 'ServerErrorException';
                    this.response.message_title = 'Register failed';
                    this.response.message = this.$_apiMessage[errorCode];
                    this.spinner.register = false;
                });
            },
        },
    };
</script>
